import React, { useEffect } from 'react'

import { SegmentAction, segmentTracking } from 'src/helpers/segment'

// Keys are the GUEST_COUNT bucket values stored by GuestCount.tsx. Ranges are anchored around the
// $3,134 average deposit.
export const GUEST_BUDGET_ANCHORS: Record<string, { guestLabel: string; range: string }> = {
  '0': { guestLabel: 'fewer than 50', range: '$2,000–2,800' },
  '50': { guestLabel: '50–100', range: '$2,400–3,200' },
  '100': { guestLabel: '100–150', range: '$2,800–3,600' },
  '200': { guestLabel: '150+', range: '$3,200–4,400' },
}

interface IBudgetAnchorNoteProps {
  guestCountBucket?: string
}

export const BudgetAnchorNote = ({ guestCountBucket }: IBudgetAnchorNoteProps) => {
  const anchor = guestCountBucket ? GUEST_BUDGET_ANCHORS[guestCountBucket] : undefined

  useEffect(() => {
    // Exposure event: the note hides itself for absent/unrecognized buckets, so the exposed
    // population cannot be reconstructed from existing data without this.
    segmentTracking(SegmentAction.SQ_BUDGET_ANCHOR_SHOWN, {
      guestCountBucket,
      range: anchor?.range,
      shown: !!anchor,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestCountBucket])

  if (!anchor) return null

  return (
    <p className="budget-anchor-note">
      Couples with {anchor.guestLabel} guests typically invest {anchor.range} with Poppy
    </p>
  )
}
